import { render } from "./DateValue.vue?vue&type=template&id=1819eb86&scoped=true"
import script from "./DateValue.vue?vue&type=script&lang=js"
export * from "./DateValue.vue?vue&type=script&lang=js"

import "./DateValue.vue?vue&type=style&index=0&id=1819eb86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1819eb86"]])

export default __exports__